import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { documentPdfPreviewTourSteps } from "./documentPdfPreviewTourSteps";

type DocumentPdfPreviewTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
    action?: string;
  }) => void;
};

export function DocumentPdfPreviewTour({
  run,
  onCallback,
}: DocumentPdfPreviewTourProps) {
  const handleCallback = (data: CallBackProps) => {
    const { status, type, index, action } = data;
    onCallback({ status, type, index, action });
  };

  return (
    <Joyride
      steps={documentPdfPreviewTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
    />
  );
}

export { useDocumentPdfPreviewTour } from "./useDocumentPdfPreviewTour";
